module.exports = new __parcel__URL__("neon_gold_accelerator_level_3.8db17e3a.png").toString();